export const FETCH_SAVED_CARDS = "FETCH_SAVED_CARDS";
export const FETCH_SAVED_CARDS_SUCCESS = "FETCH_SAVED_CARDS_SUCCESS";
export const FETCH_SAVED_CARDS_FAILURE = "FETCH_SAVED_CARDS_FAILURE";

export const SAVE_CARD = "SAVE_CARD";
export const SAVE_CARD_SUCCESS = "SAVE_CARD_SUCCESS";
export const SAVE_CARD_FAILURE = "SAVE_CARD_FAILURE";

export const PROCESS_PAYMENT = "PROCESS_PAYMENT";
export const PROCESS_PAYMENT_SUCCESS = "PROCESS_PAYMENT_SUCCESS";
export const PROCESS_PAYMENT_FAILURE = "PROCESS_PAYMENT_FAILURE";

export const CREATE_SETUP_INTENT = "CREATE_SETUP_INTENT";
export const CREATE_SETUP_INTENT_SUCCESS = "CREATE_SETUP_INTENT_SUCCESS";
export const CREATE_SETUP_INTENT_FAILURE = "CREATE_SETUP_INTENT_FAILURE";

